import React, { useState, useCallback } from 'react'
import { useTransition, animated } from 'react-spring'

const pages = [
    ({ style }) => <animated.div style={{ ...style, background: 'lightpink' }}>A</animated.div>,
    ({ style }) => <animated.div style={{ ...style, background: 'lightblue' }}>B</animated.div>,
    ({ style }) => <animated.div style={{ ...style, background: 'lightgreen' }}>
      <img height="300px" width='300px' src="https://i.imgur.com/in5Jr1h.jpg" />
    </animated.div>,
  ]

export default function ImageSlider() {
    const [index, set] = useState(0);
    const clickHandler = (res) => {set(state => (state + 1) % 3) }

    const transitions = useTransition(index, p => p, {
        from: { opacity: 0, transform: 'translate3d(-50%,0,0)' },
        enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
        leave: { opacity: 0, transform: 'translate3d(100%,0,0)' },
      })
    return (
        <>
            <button onClick={clickHandler}>prev</button>
                <div className="simple-trans-main" >
                    {transitions.map(({ item, props, key }) => {
                        const Page = pages[item]
                        return <Page key={key} style={props} />
                    })}
                    

                </div>
            <button onClick={()=>clickHandler(1)}>next</button>
        </>
    )
}
